const RiotGamesFooter  = () => {
    return (            
             <div className="text-center">
                     <strong>Email Us</strong> 
                     <h5><a href="mailto:riotgames@suiteamerica.com">riotgames@suiteamerica.com </a></h5>
             </div>
     );
}
export default RiotGamesFooter;